// @ts-nocheck
import React, {FC, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import {Typography} from '@mui/material';
import {Badge} from 'react-bootstrap';
import Moment from 'react-moment';

interface MachineListProps {
  isLoading: boolean;
  machines: Machine[];
}

export const MachineList: FC<MachineListProps> = ({isLoading, machines}) => {
  const navigate = useNavigate();

  const columns = useMemo(
      () => [
        {accessorKey: 'id', header: 'ID'},
        {accessorKey: 'machine_serial_no', header: 'SN'},
        {accessorKey: 'model', header: 'Model'},
        {accessorKey: 'dealer_name', header: 'Dealer'},
        {accessorKey: 'customer_name', header: 'Customer'},
        {
          accessorKey: 'installation_date',
          header: 'Installation',
          Cell: ({cell}) =>
          cell.getValue() ? <Moment format="DD-MM-YYYY">{cell.getValue()}</Moment> : '',
        },
        {
          accessorKey: 'created_at',
          header: 'Input',
          Cell: ({cell}) => <Moment format="DD-MM-YYYY">{cell.getValue()}</Moment>,
        },
        {
          accessorKey: 'guarantee_state',
          header: 'Status',
          Cell: ({cell}) => (
            <Badge
              pill
              variant={cell.getValue() === 1 ? 'success' : 'danger'}
              className={cell.getValue() === 1 ? 'badge-soft-success' : 'badge-soft-danger'}
            >
              {cell.getValue() === 1 ? 'In guarantee' : 'Not in guarantee'}
            </Badge>
          ),
        },
        {accessorKey: 'printer_serial_no', header: 'Printer'},
      ],
      [],
  );

  const data = useMemo(
      () =>
        machines.map((machine) => ({
          id: machine.id,
          machine_serial_no: machine.machine_serial_no,
          model: machine.model,
          dealer_name: machine.dealer?.name || '',
          customer_name: machine.customer?.name || '',
          printer_type: machine.printer_type,
          installation_date: machine.installation_date,
          created_at: machine.created_at,
          guarantee_state: machine.guarantee_state,
          printer_serial_no: machine.printer?.printer_serial_no || '',
        })),
      [machines],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      enableSorting
      enableColumnFilters
      enablePagination
      enableGlobalFilter
      state={{isLoading}}
      muiTablePaperProps={{
        elevation: 0,
      }}
      muiTableBodyRowProps={({row}) => ({
        onClick: () => navigate(`/machine/${row.original.id}`),
        style: {cursor: 'pointer'},
      })}
      renderTopToolbarCustomActions={() =>
        <Typography variant="h6">Machines</Typography>
      }
    />
  );
};
